import React, { useEffect, useState } from "react";
import FilterButtons from "./FilterButtons";
import ProfilesTile from "./ProfilesTile";
import { ManageMapperLayout, LoaderWrapper } from "../../../components";
import { Row, Col, Form } from "react-bootstrap";
import { searchProfiles } from "../../../services";
import {
  MANAGE_MAPPER_ROUTES,
  getPathWithParam,
  MANAGE_MAPPER_PROFILES_OFFSET,
} from "../../../utils";
import { useDeepEffect } from "../../../abstracts";
import InfiniteScroll from "react-infinite-scroller";
import MapperHomeSearch from "../../../components/MapperHomeSearch/MapperHomeSearch";

const MapperHomeContainer = (props) => {
  const [filterValue, setfilterValue] = useState("All");
  const [loading, setLoading] = useState(false);
  const { history } = props;
  const [request, setRequest] = useState({
    searchString: "",
    //MapType:0,
    from: 0,
    offset: MANAGE_MAPPER_PROFILES_OFFSET,
    filter: null,
  });
  const [stopInfiniteScroll, setStopInfiniteScroll] = useState(false);

  const handleSearchChange = (val) => {
    if (request.searchString !== val) {
      setStopInfiniteScroll(false);
      setProfiles([]);
      setRequest({
        ...request,
        searchString: val,
        from: 0,
        to: 100,
        offset: MANAGE_MAPPER_PROFILES_OFFSET,
      });
    }
  };
  const [Profiles, setProfiles] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  useDeepEffect(() => {
    setLoading(true);
    searchProfiles(request)
      .then((response) => {
        if (response?.mapperSearchList?.length < MANAGE_MAPPER_PROFILES_OFFSET)
          setStopInfiniteScroll(true);
        setProfiles([...Profiles, ...response?.mapperSearchList]);
        setTotalCount(response?.count);
        setLoading(false);
      })
      .finally(() => setLoading(false));
  }, [request]);

  const onClick = () => {
    history.push(
      getPathWithParam({
        path: MANAGE_MAPPER_ROUTES.BASIC_INFORMATION,
      })
    );
  };

  const buttons = [
    {
      label: "New Library",
      variant: "primary",
      type: "submit",
      onClick: onClick,
    },
  ];

  const filterButtons = [
    {
      label: "All",
      value: null,
    },
    { label: "Input", value: 1 },
    { label: "Output", value: 2 },
    { label: "Passthrough", value: 3 },
  ];

  return (
    <LoaderWrapper isLoading={loading}>
      <ManageMapperLayout
        buttons={buttons}
        donotShowBreadcrumbs={true}
        layoutHeader="Manage Data Library"
      >
        <Row className="mr-1 mt-2">
          <Col>
            <Form>
              <MapperHomeSearch
                searchPayloadKey="searchString"
                labelKey="name"
                handleSelect={handleSearchChange}
                placeholder="Search input library here..."
                method={searchProfiles}
                screen="mapper"
              />
            </Form>
          </Col>
        </Row>

        <div className="d-flex ml-1 mt-4">
          <FilterButtons
            setfilterValue={setfilterValue}
            filterValue={filterValue}
            filterButtons={filterButtons}
            request={request}
            setRequest={setRequest}
            setProfiles={setProfiles}
            setStopInfiniteScroll={setStopInfiniteScroll}
          />{" "}
          <div className="ml-auto mt-3 mr-4 font-weight-bold">
            {(Profiles ? Profiles.length : "0") + "/" + totalCount + " Maps"}
          </div>
        </div>

        <div className="ml-auto mr-3">
          <div
            style={{
              // position: "fixed",
              left: "75px",
              right: "15px",
              height: "66vh",
              overflow: "scroll",
              borderRadius: "5px",
            }}
          >
            <InfiniteScroll
              pageStart={0}
              loadMore={() => {
                setRequest({
                  ...request,
                  from: Profiles.length,
                });
              }}
              hasMore={!stopInfiniteScroll}
              initialLoad={false}
              threshold={100}
              useWindow={false}
              loader={
                <div className="loader" key={0}>
                  Loading ...
                </div>
              }
            >
              {Profiles &&
                Profiles.map((profile) => {
                  return (
                    <ProfilesTile
                      profileType={profile?.isOutput ? 2 : profile?.mapType}
                      mapperProfileName={profile.name}
                      description={profile.description}
                      targetType={profile.targetType}
                      sourceType={profile.sourceType}
                      category={profile.dataModel}
                      level={profile.level}
                      associatedPlans={
                        profile.associatedPlans ? profile.associatedPlans : null
                      }
                      isActive={profile.isActive}
                      profileId={profile.id}
                      mapType={profile.mapType}
                    />
                  );
                })}
            </InfiniteScroll>
          </div>
        </div>
      </ManageMapperLayout>
    </LoaderWrapper>
  );
};

export default MapperHomeContainer;
